import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CSS = `
  /* ═══════ HERO ═══════ */
  .pf-hero {
    min-height: 100vh; padding: 130px 0 80px;
    position: relative; overflow: hidden;
    display: flex; align-items: center;
  }
  .pf-hero-bg {
    position: absolute; inset: 0; pointer-events: none;
    background:
      radial-gradient(ellipse 50% 45% at 10% 50%, rgba(255,107,53,0.06) 0%, transparent 55%),
      radial-gradient(ellipse 45% 40% at 90% 20%, rgba(0,212,170,0.05) 0%, transparent 50%),
      radial-gradient(ellipse 50% 50% at 50% 100%, rgba(124,92,252,0.04) 0%, transparent 50%);
  }
  .pf-hero-grid {
    position: absolute; inset: 0; pointer-events: none;
    background-image:
      linear-gradient(rgba(255,107,53,0.02) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,107,53,0.02) 1px, transparent 1px);
    background-size: 60px 60px;
    mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black, transparent);
    -webkit-mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black, transparent);
  }
  .pf-hero-wrap {
    max-width: 1200px; margin: 0 auto; padding: 0 24px;
    display: flex; align-items: center; gap: 60px;
    position: relative; z-index: 1; width: 100%;
  }

  /* ── Left ── */
  .pf-hero-left { flex: 1; min-width: 0; }
  .pf-hero-left > * { animation: fadeInUp 0.7s ease both; }
  .pf-hero-left > *:nth-child(1) { animation-delay: 0.1s; }
  .pf-hero-left > *:nth-child(2) { animation-delay: 0.2s; }
  .pf-hero-left > *:nth-child(3) { animation-delay: 0.3s; }
  .pf-hero-left > *:nth-child(4) { animation-delay: 0.4s; }
  .pf-hero-left > *:nth-child(5) { animation-delay: 0.5s; }
  .pf-hero-left > *:nth-child(6) { animation-delay: 0.6s; }
  .pf-hero-left > *:nth-child(7) { animation-delay: 0.65s; }

  .pf-hero-badge {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 6px 16px 6px 8px; border-radius: 30px;
    background: rgba(255,107,53,0.08); border: 1px solid rgba(255,107,53,0.15);
    margin-bottom: 24px;
  }
  .pf-hero-badge-dot {
    width: 8px; height: 8px; border-radius: 50%;
    background: #00D4AA; box-shadow: 0 0 10px rgba(0,212,170,0.8);
    animation: pfDotPulse 2s ease-in-out infinite;
  }
  @keyframes pfDotPulse { 0%,100%{box-shadow:0 0 8px rgba(0,212,170,0.5)} 50%{box-shadow:0 0 18px rgba(0,212,170,1)} }
  .pf-hero-badge span {
    font-family: 'Plus Jakarta Sans', sans-serif; font-size: 0.72em; font-weight: 700;
    color: #FF6B35; letter-spacing: 0.5px;
  }

  .pf-hero-title {
    font-family: 'DM Serif Display', serif;
    font-size: clamp(2.6em, 5vw, 4.2em);
    font-weight: 400; line-height: 1.1;
    color: #F0F0F5; margin-bottom: 20px;
  }
  .pf-hero-title em {
    font-style: italic;
    background: linear-gradient(135deg, #FF6B35, #FFD23F, #00D4AA);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .pf-hero-desc {
    font-size: 1.05em; color: rgba(240,240,245,0.5);
    max-width: 480px; line-height: 1.8; margin-bottom: 32px;
  }

  .pf-hero-stats {
    display: flex; flex-wrap: wrap; gap: 0;
    border: 1px solid rgba(255,255,255,0.06); border-radius: 16px;
    overflow: hidden; width: fit-content; margin-bottom: 32px;
  }
  .pf-hero-stat {
    padding: 16px 24px; text-align: center;
    border-right: 1px solid rgba(255,255,255,0.05);
    transition: background 0.3s ease;
  }
  .pf-hero-stat:last-child { border-right: none; }
  .pf-hero-stat:hover { background: rgba(255,107,53,0.04); }
  .pf-hero-stat-n {
    font-family: 'DM Serif Display', serif; font-size: 1.5em;
    display: block; line-height: 1;
    background: linear-gradient(135deg, #FF6B35, #FFD23F);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .pf-hero-stat-l {
    font-size: 0.68em; font-weight: 500;
    color: rgba(240,240,245,0.3); margin-top: 4px; display: block;
  }

  .pf-hero-ctas { display: flex; flex-wrap: wrap; gap: 14px; }

  /* ── Right — Floating Cards ── */
  .pf-hero-right {
    flex-shrink: 0; width: 420px; position: relative;
    animation: fadeInRight 0.9s ease 0.3s both;
  }
  .pf-float-container {
    position: relative; width: 100%; height: 440px;
  }
  .pf-float-card {
    position: absolute; border-radius: 20px; padding: 20px;
    background: rgba(255,255,255,0.035); border: 1px solid rgba(255,255,255,0.06);
    backdrop-filter: blur(16px); cursor: default;
    transition: all 0.4s cubic-bezier(0.22,1,0.36,1);
    box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  }
  .pf-float-card:hover {
    transform: translateY(-8px) !important;
    box-shadow: 0 20px 50px rgba(0,0,0,0.35);
    border-color: rgba(255,255,255,0.1);
  }
  .pf-fc-1 { top: 0; left: 0; width: 200px; animation: float 5s ease-in-out infinite; }
  .pf-fc-2 { top: 40px; right: 0; width: 190px; animation: float 6s ease-in-out 0.5s infinite; }
  .pf-fc-3 { top: 190px; left: 30px; width: 230px; animation: float 5.5s ease-in-out 1s infinite; }
  .pf-fc-4 { bottom: 20px; right: 10px; width: 200px; animation: float 4.5s ease-in-out 1.5s infinite; }

  .pf-fc-emoji { font-size: 2em; margin-bottom: 8px; display: block; }
  .pf-fc-title {
    font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 700;
    font-size: 0.88em; color: #F0F0F5; margin-bottom: 4px;
  }
  .pf-fc-sub {
    font-size: 0.72em; color: rgba(240,240,245,0.35); line-height: 1.5;
  }
  .pf-fc-bar-wrap {
    margin-top: 10px; height: 4px; border-radius: 4px;
    background: rgba(255,255,255,0.06); overflow: hidden;
  }
  .pf-fc-bar {
    height: 100%; border-radius: 4px;
    transition: width 2s ease;
  }

  /* ═══════ FEATURES ═══════ */
  .pf-features { padding: 100px 0 80px; position: relative; }
  .pf-features-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;
    margin-top: 48px;
  }
  .pf-feat-card {
    position: relative; padding: 32px 24px; border-radius: 20px;
    background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.05);
    overflow: hidden; cursor: default;
    transition: all 0.4s cubic-bezier(0.22,1,0.36,1);
    animation: fadeInUp 0.6s ease both;
  }
  .pf-feat-card:nth-child(1) { animation-delay: 0.1s; }
  .pf-feat-card:nth-child(2) { animation-delay: 0.2s; }
  .pf-feat-card:nth-child(3) { animation-delay: 0.3s; }
  .pf-feat-card:nth-child(4) { animation-delay: 0.4s; }
  .pf-feat-card:nth-child(5) { animation-delay: 0.5s; }
  .pf-feat-card:nth-child(6) { animation-delay: 0.6s; }

  .pf-feat-card::before {
    content: ''; position: absolute; top: 0; left: -100%;
    width: 60%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,107,53,0.04), transparent);
    transition: left 0.5s ease; pointer-events: none;
  }
  .pf-feat-card:hover::before { left: 160%; }
  .pf-feat-card:hover {
    background: rgba(255,255,255,0.045);
    border-color: rgba(255,107,53,0.15);
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0,0,0,0.2);
  }
  .pf-feat-icon {
    width: 52px; height: 52px; border-radius: 16px; margin-bottom: 18px;
    display: flex; align-items: center; justify-content: center;
    font-size: 1.5em; transition: all 0.3s ease;
  }
  .pf-feat-card:hover .pf-feat-icon {
    transform: scale(1.1) rotate(-5deg);
    box-shadow: 0 0 24px rgba(255,107,53,0.2);
  }
  .pf-feat-title {
    font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 800;
    font-size: 1em; color: #F0F0F5; margin-bottom: 8px;
  }
  .pf-feat-desc {
    font-size: 0.84em; color: rgba(240,240,245,0.4); line-height: 1.7;
  }

  /* ═══════ HOW IT WORKS ═══════ */
  .pf-how { padding: 80px 0; }
  .pf-how-steps {
    display: flex; gap: 0; margin-top: 48px;
    position: relative;
  }
  .pf-how-steps::before {
    content: ''; position: absolute; top: 36px; left: 60px; right: 60px;
    height: 2px;
    background: linear-gradient(90deg, #FF6B35, #FFD23F, #00D4AA, #7C5CFC);
    opacity: 0.15;
  }
  .pf-how-step {
    flex: 1; text-align: center; padding: 0 16px; position: relative;
    animation: fadeInUp 0.6s ease both;
  }
  .pf-how-step:nth-child(1) { animation-delay: 0.1s; }
  .pf-how-step:nth-child(2) { animation-delay: 0.25s; }
  .pf-how-step:nth-child(3) { animation-delay: 0.4s; }
  .pf-how-step:nth-child(4) { animation-delay: 0.55s; }
  .pf-how-num {
    width: 72px; height: 72px; border-radius: 50%;
    margin: 0 auto 18px; display: flex; align-items: center; justify-content: center;
    font-family: 'DM Serif Display', serif; font-size: 1.5em;
    position: relative; z-index: 1;
    transition: all 0.3s ease;
  }
  .pf-how-step:hover .pf-how-num {
    transform: scale(1.1);
    box-shadow: 0 0 30px rgba(255,107,53,0.2);
  }
  .pf-how-step-title {
    font-weight: 700; font-size: 0.95em; color: #F0F0F5; margin-bottom: 6px;
  }
  .pf-how-step-desc {
    font-size: 0.8em; color: rgba(240,240,245,0.35); line-height: 1.6;
  }

  /* ═══════ CTA BOTTOM ═══════ */
  .pf-cta-section { padding: 60px 0 100px; }
  .pf-cta-box {
    padding: 56px 48px; border-radius: 28px; text-align: center;
    background: linear-gradient(135deg, rgba(255,107,53,0.08) 0%, rgba(124,92,252,0.06) 50%, rgba(0,212,170,0.05) 100%);
    border: 1px solid rgba(255,107,53,0.12);
    position: relative; overflow: hidden;
  }
  .pf-cta-box::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 50% 50% at 50% 100%, rgba(255,107,53,0.08), transparent);
    pointer-events: none;
  }
  .pf-cta-title {
    font-family: 'DM Serif Display', serif; font-size: clamp(1.8em, 3vw, 2.4em);
    color: #F0F0F5; margin-bottom: 14px; position: relative;
  }
  .pf-cta-sub {
    font-size: 0.95em; color: rgba(240,240,245,0.4);
    margin-bottom: 28px; line-height: 1.7; max-width: 500px;
    margin-left: auto; margin-right: auto; position: relative;
  }

  /* ═══════ RESPONSIVE ═══════ */
  @media(max-width: 992px) {
    .pf-hero-wrap { flex-direction: column; text-align: center; gap: 40px; }
    .pf-hero-left { display: flex; flex-direction: column; align-items: center; }
    .pf-hero-desc { text-align: center; }
    .pf-hero-right { width: 100%; max-width: 400px; }
    .pf-float-container { height: 380px; }
    .pf-hero-ctas { justify-content: center; }
    .pf-hero-stats { justify-content: center; }
  }
  @media(max-width: 768px) {
    .pf-features-grid { grid-template-columns: 1fr 1fr; }
    .pf-how-steps { flex-direction: column; gap: 28px; }
    .pf-how-steps::before { display: none; }
    .pf-hero-right { display: none; }
  }
  @media(max-width: 480px) {
    .pf-features-grid { grid-template-columns: 1fr; }
    .pf-hero-stat { padding: 12px 16px; }
  }
`;

const FEATURES = [
  {
    icon: "🧠",
    bg: "rgba(255,107,53,0.1)",
    border: "rgba(255,107,53,0.2)",
    title: "AI-Powered Career Test",
    desc: "35 psychometric questions that measure your personality, interests, and aptitude to find your perfect career.",
  },
  {
    icon: "🎯",
    bg: "rgba(0,212,170,0.1)",
    border: "rgba(0,212,170,0.2)",
    title: "Personalized Matches",
    desc: "Get your top 3 career matches with detailed explanations of why you're a great fit for each one.",
  },
  {
    icon: "📚",
    bg: "rgba(124,92,252,0.1)",
    border: "rgba(124,92,252,0.2)",
    title: "Career Library",
    desc: "Explore 10+ career paths with salaries, required skills, top colleges, and complete roadmaps for India.",
  },
  {
    icon: "🗺️",
    bg: "rgba(255,210,63,0.1)",
    border: "rgba(255,210,63,0.2)",
    title: "Stream Selection Guide",
    desc: "Confused between Science, Commerce, Arts? Our guide helps you pick the right stream after 10th.",
  },
  {
    icon: "📊",
    bg: "rgba(255,77,106,0.1)",
    border: "rgba(255,77,106,0.2)",
    title: "Personal Dashboard",
    desc: "Save your results, track career interests, and build a personalized learning roadmap over time.",
  },
  {
    icon: "🇮🇳",
    bg: "rgba(0,212,170,0.08)",
    border: "rgba(0,212,170,0.15)",
    title: "Made for India",
    desc: "Every career path, salary, college recommendation, and roadmap is 100% tailored for Indian students.",
  },
];

const STEPS = [
  {
    num: "01",
    color: "#FF6B35",
    bg: "rgba(255,107,53,0.1)",
    border: "rgba(255,107,53,0.2)",
    title: "Take the Test",
    desc: "Answer 35 fun questions about your personality and interests",
  },
  {
    num: "02",
    color: "#FFD23F",
    bg: "rgba(255,210,63,0.1)",
    border: "rgba(255,210,63,0.2)",
    title: "Get Your Profile",
    desc: "Discover your unique personality type and trait breakdown",
  },
  {
    num: "03",
    color: "#00D4AA",
    bg: "rgba(0,212,170,0.1)",
    border: "rgba(0,212,170,0.2)",
    title: "See Career Matches",
    desc: "Get your top 3 recommended careers with match percentages",
  },
  {
    num: "04",
    color: "#7C5CFC",
    bg: "rgba(124,92,252,0.1)",
    border: "rgba(124,92,252,0.2)",
    title: "Plan Your Path",
    desc: "Follow the step-by-step roadmap from 10th to your dream career",
  },
];

export default function Landing() {
  const [counter, setCounter] = useState({
    students: 0,
    careers: 0,
    questions: 0,
  });
  useEffect(() => {
    const t = setTimeout(
      () => setCounter({ students: 12400, careers: 10, questions: 35 }),
      800,
    );
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <style>{CSS}</style>

      {/* ═══════ HERO ═══════ */}
      <section className="pf-hero">
        <div className="pf-hero-bg" />
        <div className="pf-hero-grid" />
        <div className="pf-hero-wrap">
          <div className="pf-hero-left">
            <div className="pf-hero-badge">
              <div className="pf-hero-badge-dot" />
              <span>Free Career Guidance for Class 10 Students</span>
            </div>
            <h1 className="pf-hero-title">
              Confused About
              <br />
              Career After <em>10th?</em>
            </h1>
            <p className="pf-hero-desc">
              Take our 5-minute psychometric test and discover the perfect
              career path designed for you. Built specifically for Indian
              students with real salary data, college recommendations, and
              step-by-step roadmaps.
            </p>
            <div className="pf-hero-stats">
              {[
                ["12K+", "Students Tested"],
                ["10+", "Career Paths"],
                ["35", "Smart Questions"],
                ["100%", "Free"],
              ].map(([n, l]) => (
                <div className="pf-hero-stat" key={l}>
                  <span className="pf-hero-stat-n">{n}</span>
                  <span className="pf-hero-stat-l">{l}</span>
                </div>
              ))}
            </div>
            <div className="pf-hero-ctas">
              <Link to="/test" className="btn-primary">
                🚀 Take Career Test — It's Free
              </Link>
              <Link to="/careers" className="btn-secondary">
                📚 Explore Careers
              </Link>
            </div>
          </div>

          <div className="pf-hero-right">
            <div className="pf-float-container">
              <div className="pf-float-card pf-fc-1">
                <span className="pf-fc-emoji">🤖</span>
                <div className="pf-fc-title">AI Engineer</div>
                <div className="pf-fc-sub">₹6-80L+ per year</div>
                <div className="pf-fc-bar-wrap">
                  <div
                    className="pf-fc-bar"
                    style={{
                      width: "92%",
                      background: "linear-gradient(90deg, #6C5CE7, #A29BFE)",
                    }}
                  />
                </div>
              </div>
              <div className="pf-float-card pf-fc-2">
                <span className="pf-fc-emoji">🩺</span>
                <div className="pf-fc-title">Doctor</div>
                <div className="pf-fc-sub">₹6L-2Cr+ per year</div>
                <div className="pf-fc-bar-wrap">
                  <div
                    className="pf-fc-bar"
                    style={{
                      width: "88%",
                      background: "linear-gradient(90deg, #E17055, #FDCB6E)",
                    }}
                  />
                </div>
              </div>
              <div className="pf-float-card pf-fc-3">
                <span className="pf-fc-emoji">📊</span>
                <div className="pf-fc-title">Your Personality</div>
                <div className="pf-fc-sub">Analytical · Creative · Social</div>
                <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
                  {["#FF6B35", "#00D4AA", "#FFD23F", "#7C5CFC", "#FF4D6A"].map(
                    (c, i) => (
                      <div
                        key={i}
                        style={{
                          flex: [35, 25, 20, 12, 8][i],
                          height: 6,
                          borderRadius: 3,
                          background: c,
                          opacity: 0.7,
                        }}
                      />
                    ),
                  )}
                </div>
              </div>
              <div className="pf-float-card pf-fc-4">
                <span className="pf-fc-emoji">🎯</span>
                <div className="pf-fc-title">92% Match!</div>
                <div className="pf-fc-sub">Software Developer</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════ FEATURES ═══════ */}
      <section className="pf-features">
        <div className="container" style={{ textAlign: "center" }}>
          <div className="section-badge">✨ Platform Features</div>
          <h2 className="section-title">
            Everything You Need to
            <br />
            <em>Choose Your Future</em>
          </h2>
          <p className="section-subtitle" style={{ margin: "0 auto 0" }}>
            From psychometric assessment to career roadmaps — we've built the
            complete toolkit for India's Class 10 students.
          </p>
          <div className="pf-features-grid">
            {FEATURES.map((f, i) => (
              <div className="pf-feat-card" key={i}>
                <div
                  className="pf-feat-icon"
                  style={{ background: f.bg, border: `1px solid ${f.border}` }}
                >
                  {f.icon}
                </div>
                <div className="pf-feat-title">{f.title}</div>
                <div className="pf-feat-desc">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════ HOW IT WORKS ═══════ */}
      <section className="pf-how">
        <div className="container" style={{ textAlign: "center" }}>
          <div className="section-badge">🔄 How It Works</div>
          <h2 className="section-title">
            4 Simple Steps to
            <br />
            <em>Your Dream Career</em>
          </h2>
          <div className="pf-how-steps">
            {STEPS.map((s, i) => (
              <div className="pf-how-step" key={i}>
                <div
                  className="pf-how-num"
                  style={{
                    background: s.bg,
                    border: `1.5px solid ${s.border}`,
                    color: s.color,
                  }}
                >
                  {s.num}
                </div>
                <div className="pf-how-step-title">{s.title}</div>
                <div className="pf-how-step-desc">{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════ CTA ═══════ */}
      <section className="pf-cta-section">
        <div className="container">
          <div className="pf-cta-box">
            <h2 className="pf-cta-title">
              Ready to Discover Your{" "}
              <span className="gradient-text">Perfect Career?</span>
            </h2>
            <p className="pf-cta-sub">
              Join 12,000+ students who found clarity about their future. It
              takes just 5 minutes. No sign-up required.
            </p>
            <Link
              to="/test"
              className="btn-primary"
              style={{ position: "relative" }}
            >
              🚀 Start the Career Test Now
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
